import src from "IMAGE";
export default { src, width: 460, height: 460, blurWidth: 0, blurHeight: 0};
